import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "../../lib/api";
import { Logo } from "../../components/Logo";
import { Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(apiError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md animate-fade-up">
        <div className="mb-8 flex justify-center"><Logo size="lg" align="center" /></div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-xl shadow-slate-900/5 p-8">
          {sent ? (
            <div className="text-center">
              <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-3" />
              <h2 className="font-head text-xl font-bold text-slate-900">Check your email</h2>
              <p className="text-slate-500 text-sm mt-2">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
              <Link to="/login" className="inline-flex items-center gap-2 text-blue-600 font-medium mt-6 hover:underline"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
            </div>
          ) : (
            <>
              <h2 className="font-head text-2xl font-bold text-slate-900">Reset password</h2>
              <p className="text-slate-500 text-sm mt-1 mb-6">Enter your account email and we'll send you a reset link.</p>
              {error && <div className="bg-rose-50 border border-rose-200 text-rose-700 text-sm rounded-lg px-3.5 py-2.5 mb-4">{error}</div>}
              <form onSubmit={submit} className="space-y-4">
                <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@gdiot.in"
                  className="w-full bg-slate-50 border border-slate-300 rounded-lg px-3.5 py-2.5 text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
                <button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl flex items-center justify-center gap-2 disabled:opacity-60">
                  {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send reset link
                </button>
              </form>
              <Link to="/login" className="inline-flex items-center gap-2 text-slate-500 text-sm mt-6 hover:text-slate-700"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
